import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Tooltip from '@material-ui/core/Tooltip';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import MaterialTableBody from '@material-ui/core/TableBody';
import { formatDateTime, getInternalStatus, formatPrice } from '~/common';
import CellAffiliateName from './CellAffiliateName';

const TableBody = (props) => {
    const getClassName = (lead) => {
        let className = 'context-menu';
        if (props.selectedLead && lead.id === props.selectedLead.id) {
            className += ' selected';
        }
        return className;
    };

    // noinspection JSUnresolvedVariable,JSValidateTypes
    return (
        <MaterialTableBody>
            {props.leads.map((lead) => (
                <TableRow key={lead.id} className={getClassName(lead)} onContextMenu={props.onContextMenu(lead)}>
                    <TableCell className="adv_sub">
                        <Typography noWrap={true}>
                            <Link to={`/leads/${lead.id}/`}>{lead.adv_sub}</Link>
                        </Typography>
                    </TableCell>
                    <TableCell className="offer">
                        <Typography noWrap={true}>
                            {(!props.user.affiliate)
                                ? <Link to={`/offers/${lead.offer.offer_name}/`}>{lead.offer.offer_name}</Link>
                                : `${lead.offer.offer_name}`
                            }
                        </Typography>
                    </TableCell>
                    {(!props.user.affiliate)
                        ? <CellAffiliateName affiliateId={lead.affiliate_id} affiliateName={lead.affiliate_name}/>
                        : null
                    }
                    {(props.cols.type)
                        ? <>
                            {(lead.type)
                                ? <Tooltip title={lead.type.code} placement="left" arrow={true}>
                                    <TableCell className="type">
                                        <Typography noWrap={true}>{lead.type.name}</Typography>
                                    </TableCell>
                                </Tooltip>
                                : <TableCell className="type"/>
                            }
                        </>
                        : null
                    }
                    <TableCell className="datetime">{formatDateTime(new Date(lead.datetime))}</TableCell>
                    <TableCell className="source"><Typography noWrap={true}>{lead.source}</Typography></TableCell>
                    <TableCell className="aff_sub"><Typography noWrap={true}>{lead.aff_sub}</Typography></TableCell>
                    {(props.cols.advSub2)
                        ? <TableCell className="adv_sub2"><Typography noWrap={true}>
                            {lead.adv_sub2}
                        </Typography></TableCell>
                        : null
                    }
                    {(props.cols.dts)
                        ? <TableCell className="datetime_status">{formatDateTime(new Date(lead.datetime_status))}</TableCell>
                        : null
                    }
                    {(lead.status)
                        ? (lead.status.status)
                            ? <Tooltip title={lead.status.status} placement="left" arrow={true}
                            >
                                <TableCell className="status">
                                    <Typography>{getInternalStatus(lead.status.internal)}</Typography>
                                </TableCell>
                            </Tooltip>
                            : <TableCell className="status">
                                <Typography>{getInternalStatus(lead.status.internal)}</Typography>
                            </TableCell>
                        : <TableCell className="status"/>
                    }
                    <TableCell className="price">
                        <Typography align="right">{formatPrice(lead.price)}</Typography>
                    </TableCell>
                    {(props.cols.transactionId)
                        ? <TableCell className="transaction_id">
                            <Typography noWrap={true}>{lead.transaction_id}</Typography>
                        </TableCell>
                        : null
                    }
                </TableRow>
            ))}
        </MaterialTableBody>
    );
};

TableBody.propTypes = {
    cols: PropTypes.object.isRequired,
    leads: PropTypes.array.isRequired,
    onContextMenu: PropTypes.func.isRequired,
};

let MemoizedComponent = React.memo(TableBody, (prevProps, nextProps) => {
    // noinspection JSUnresolvedVariable
    const prevSelectedLead = prevProps.selectedLead;
    // noinspection JSUnresolvedVariable
    const nextSelectedLead = nextProps.selectedLead;

    // noinspection RedundantIfStatementJS
    if (prevSelectedLead !== nextSelectedLead) {
        return false;
    }

    return true;
});

export default connect(
    (state) => ({
        user: state.auth.user,
    }),
    null,
)(MemoizedComponent);
